import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import isNil from 'lodash/isNil';
import React from 'react';
import AbbreviatedNumberTooltip from "../Common/AbbreviatedNumberTooltip";
import { allAppsWidth } from "../Common/ReportsTableSummary";
import { reportNameToTableHeaderMap } from "./CloudChurnOrRenewals.types";
import { getCloudChurnOrRenewalTableData } from "./CloudChurnOrRenewals.utils";
export const Cell = _styled("div", {
  target: "e1lnp54l0",
  label: "Cell"
})(process.env.NODE_ENV === "production" ? {
  name: "o6l5fu",
  styles: "padding:5px 0;"
} : {
  name: "o6l5fu",
  styles: "padding:5px 0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const totalColumns = 6;
const style = {
  width: "".concat((100 - allAppsWidth) / totalColumns, "%")
};
export const getCloudReportHeader = reportName => ({
  cells: [{
    key: 'string',
    content: 'App',
    isSortable: true,
    style: {
      width: "".concat(allAppsWidth, "%")
    }
  }, {
    key: 'monthlyTotal',
    content: reportNameToTableHeaderMap[reportName].total,
    isSortable: true,
    style
  }, {
    key: 'monthlyActual',
    content: reportNameToTableHeaderMap[reportName].actual,
    isSortable: true,
    style
  }, {
    key: 'monthlyRate',
    content: reportNameToTableHeaderMap[reportName].rate,
    isSortable: true,
    style
  }, {
    key: 'annualTotal',
    content: reportNameToTableHeaderMap[reportName].total,
    isSortable: true,
    style
  }, {
    key: 'annualActual',
    content: reportNameToTableHeaderMap[reportName].actual,
    isSortable: true,
    style
  }, {
    key: 'annualRate',
    content: reportNameToTableHeaderMap[reportName].rate,
    isSortable: true,
    style
  }]
});
export const getCloudChurnOrRenewalsBody = (response, reportName) => {
  if (!response) {
    return [];
  }

  const tableData = getCloudChurnOrRenewalTableData(response, reportName);
  return tableData.map(item => {
    var _item$monthly$total, _item$monthly$actual, _item$monthly$rate, _item$annual$total, _item$annual$actual, _item$annual$rate;

    return {
      key: item.appKey,
      cells: [{
        key: item.appName,
        content: /*#__PURE__*/React.createElement(Cell, null, item.appName)
      }, {
        key: (_item$monthly$total = item.monthly.total) !== null && _item$monthly$total !== void 0 ? _item$monthly$total : -1,
        content: /*#__PURE__*/React.createElement(AbbreviatedNumberTooltip, {
          value: item.monthly.total
        })
      }, {
        key: (_item$monthly$actual = item.monthly.actual) !== null && _item$monthly$actual !== void 0 ? _item$monthly$actual : -1,
        content: /*#__PURE__*/React.createElement(AbbreviatedNumberTooltip, {
          value: item.monthly.actual
        })
      }, {
        key: (_item$monthly$rate = item.monthly.rate) !== null && _item$monthly$rate !== void 0 ? _item$monthly$rate : -1,
        content: isNil(item.monthly.rate) ? '--' : "".concat(item.monthly.rate, "%")
      }, {
        key: (_item$annual$total = item.annual.total) !== null && _item$annual$total !== void 0 ? _item$annual$total : -1,
        content: /*#__PURE__*/React.createElement(AbbreviatedNumberTooltip, {
          value: item.annual.total
        })
      }, {
        key: (_item$annual$actual = item.annual.actual) !== null && _item$annual$actual !== void 0 ? _item$annual$actual : -1,
        content: /*#__PURE__*/React.createElement(AbbreviatedNumberTooltip, {
          value: item.annual.actual
        })
      }, {
        key: (_item$annual$rate = item.annual.rate) !== null && _item$annual$rate !== void 0 ? _item$annual$rate : -1,
        content: isNil(item.annual.rate) ? '--' : "".concat(item.annual.rate, "%")
      }]
    };
  });
};